/* @flow */

import React from 'react'
import { connect } from 'react-redux'

import type { Alert as AlertType, RootState, Dispatch } from '../types'

import { unsetAlert, selectAlert } from '../stores/alert'

type Props = {
  alert: ?AlertType,
  unsetAlert: () => void,
}

type StateProps = {
  alert: ?AlertType,
}

type DispatchProps = $Diff<Props, StateProps>

function Alert(props: Props) {
  const alert = props.alert

  if (alert == null) {
    return null
  }

  let backgroundClass, colorClass
  switch (alert.type) {
    case 'success': {
      backgroundClass = 'bg-green'
      colorClass = 'green'
      break
    }
    case 'info': {
      backgroundClass = 'bg-op-brand'
      colorClass = 'op-brand'
      break
    }
    case 'warning': {
      backgroundClass = 'bg-op-brand'
      colorClass = 'op-brand'
      break
    }
    case 'danger': {
      backgroundClass = 'bg-dark-red'
      colorClass = 'dark-red'
      break
    }
    default: {
      backgroundClass = 'bg-moon-gray'
      colorClass = 'moon-gray'
    }
  }

  return (
    <div
      className={`alert bg-white f5 fw5 h3 flex items-center ${colorClass}`}
      style={{ minWidth: '25vw' }}
    >
      <div
        className={`dib h-100 mr3 ${backgroundClass}`}
        style={{ width: '10px' }}
      ></div>
      <span className="mr3">{alert.message}</span>
      <i
        className="fa fa-times ml-auto mr3 moon-gray pointer"
        onClick={props.unsetAlert}
      ></i>
    </div>
  )
}

function mapStateToProps(state: RootState): StateProps {
  return {
    alert: selectAlert(state),
  }
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
  return {
    unsetAlert() {
      return dispatch(unsetAlert())
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Alert)



// WEBPACK FOOTER //
// ./src/components/Alert.js